import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { NewNotice } from "../Images";
import ReactHtmlParser from "react-html-parser";
import { getNoticeData } from "../Service/ApiFunction";

const Notices = () => {
  const [allNoticeData, setAllNoticeData] = useState([]);

  const noticeData = async () => {
    const resNotice = await getNoticeData();
    setAllNoticeData(resNotice?.data);
  };
  useEffect(() => {
    noticeData();
  }, []);
  const DownLoadNotice = (fileName, link) => {
    const extension = link.split(".").at(-1);

    fetch(link).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);

        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = `${fileName}_notice.${extension}`;
        alink.click();
      });
    });
  };
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Notice Board</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="notice-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="ribbon red-gradient">All News and Notice</h3>
            </div>
            <div className="col-12">
              {allNoticeData?.length ? (
                <Accordion defaultActiveKey="0">
                  {allNoticeData.map((notice, index) => (
                    <Accordion.Item
                      eventKey={index}
                      key={notice.key}
                      aria-expanded={index == 0}
                    >
                      <Accordion.Header>
                        {notice?.title}
                        {notice?.isNew == "1" && <img src={NewNotice} alt="" />}
                      </Accordion.Header>{" "}
                      <Accordion.Body>
                        {ReactHtmlParser(notice?.description)}
                        {notice?.file && (
                          <>
                            <span
                              onClick={() =>
                                DownLoadNotice(notice?.title, notice?.file)
                              }
                              class="badge badge-pill badge-primary"
                              style={{
                                backgroundColor: "blue",
                                cursor: "pointer",
                              }}
                            >
                              Download Attachment
                            </span>
                          </>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              ) : (
                <>
                  <h3 style={{ color: "red", textAlign: "center" }}>
                    No Notice Data
                  </h3>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Notices;
